(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiree6a0"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiree6a0"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("fQ5gt", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $b87fcbd1503da0ef$export$6503ec6e8aabbaf; }, function (v) { return $b87fcbd1503da0ef$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $b87fcbd1503da0ef$export$f7ad0328861e2f03; }, function (v) { return $b87fcbd1503da0ef$export$f7ad0328861e2f03 = v; });
var $b87fcbd1503da0ef$export$6503ec6e8aabbaf;
var $b87fcbd1503da0ef$export$f7ad0328861e2f03;
"use strict";
var $b87fcbd1503da0ef$var$mapping = new Map();
function $b87fcbd1503da0ef$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$b87fcbd1503da0ef$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $b87fcbd1503da0ef$var$resolve(id) {
    var resolved = $b87fcbd1503da0ef$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$b87fcbd1503da0ef$export$6503ec6e8aabbaf = $b87fcbd1503da0ef$var$register;
$b87fcbd1503da0ef$export$f7ad0328861e2f03 = $b87fcbd1503da0ef$var$resolve;

});

parcelRegister("TNAMQ", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $0a7b9b2c7fa51630$export$bdfd709ae4826697; }, function (v) { return $0a7b9b2c7fa51630$export$bdfd709ae4826697 = v; });
var $0a7b9b2c7fa51630$export$bdfd709ae4826697;
var $0a7b9b2c7fa51630$export$c9e73fbda7da57b6;
var $0a7b9b2c7fa51630$export$5a759dc7a1cfb72a;
"use strict";
var $0a7b9b2c7fa51630$var$bundleURL = {};
function $0a7b9b2c7fa51630$var$getBundleURLCached(id) {
    var value = $0a7b9b2c7fa51630$var$bundleURL[id];
    if (!value) {
        value = $0a7b9b2c7fa51630$var$getBundleURL();
        $0a7b9b2c7fa51630$var$bundleURL[id] = value;
    }
    return value;
}
function $0a7b9b2c7fa51630$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $0a7b9b2c7fa51630$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $0a7b9b2c7fa51630$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $0a7b9b2c7fa51630$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$0a7b9b2c7fa51630$export$bdfd709ae4826697 = $0a7b9b2c7fa51630$var$getBundleURLCached;
$0a7b9b2c7fa51630$export$c9e73fbda7da57b6 = $0a7b9b2c7fa51630$var$getBaseURL;
$0a7b9b2c7fa51630$export$5a759dc7a1cfb72a = $0a7b9b2c7fa51630$var$getOrigin;

});

var $95573228d7d51628$exports = {};


(parcelRequire("fQ5gt")).register((parcelRequire("TNAMQ")).getBundleURL("4MIMe"), JSON.parse('["4MIMe","index.f1faa344.js","e9O29","about.d08cdacb.js","cVAG4","sandbox-override.efdec7b2.js","IH5lO","disclaimer.e4611e91.js","8rJEu","custom.1084fc0b.js","hxfxf","aparam.5d1416aa.js","iYH2K","gpmimergdaily.74e07d12.png","2kliT","GPM_3IMERGDF.data.631793f4.js","27IFi","tropess_tcr_optimized_news.dc3f255a.jpg","jXOGf","TROPESS_NOx.data.287b4063.js","kRwbq","TROPESS_O3.9e797fb6.jpg","4DYEb","TROPESS_O3.data.87c97a59.js","eNDUp","arcgis.data.61ab1091.js","dm5Q7","black-marble.data.52e56462.js","9Bl6C","east_coast_mar_20.3d5326cb.jpg","5TF2J","data-from-ghg.data.f07bdf67.js","9u2vD","no2--dataset-cover.80478047.jpg","jJx1w","fire.data.fb372daa.js","6kVFm","gedi-agb-grid-v2.1.data.0aa33541.js","85H3u","geos-casa-gfed-cover.85410fe9.jpg","aVjeS","micasa-carbonflux-daygrid-cmr-v1.data.a5a0b57d.js","flduG","nighttime-lights--dataset-cover.1cd08e26.jpg","gqs4k","nighttime-lights.data.993e73d2.js","9P4uL","nighttime-lights--wuhan-bef-after.c0b1ed92.png","3pUUR","img-placeholder-3.4c5b2358.jpg","hPsD6","no2.data.43614718.js","9HdiO","east_coast_mar_avg.6e8d4fc1.jpg","p4y5E","no2-south-america.f4744577.jpg","j1Gfm","img-placeholder-4.728679b2.jpg","d0bSm","sandbox.data.f6676278.js","lxiKm","wmts-dataset.data.c43049a3.js","5MwkE","air-quality-and-covid-19--story-cover.223fafff.jpg","iWhDN","air-quality-and-covid-19.stories.a97d83a2.js","pw1dp","external-link-example.stories.8c266e03.js","3hPOO","img-placeholder-6.88847e66.jpg","7kMZE","internal-link-example.stories.06bb57e6.js","jsgRO","life-of-water.stories.6c3f5c2c.js","iKEI5","mdx-content.883ed225.js","jzndy","mdx-content.500961b6.js","6jI14","xlsx.98af80b5.js","2ihmu","mdx-content.5aa0734f.js","4QWJW","mdx-content.c88f8776.js","avImN","mapbox-gl.afc2b420.js","fMUVA","marker-sdf.db41bce1.png","960wu","tour-comparison.b4c28c2d.gif","2goPM","tour-analysis.af1a1ea4.gif","4Yj5f","mdx-content.683757e0.css","1N2Tv","catalog-content.3ab33072.js","luCMb","catalog-content.69c6cce4.css","4N2EB","catalog-content.620f96b3.js","fuhbD","container.bfbea49f.js","bGkDe","mdx-content.0fa923d0.js","2ADxp","mdx-content.48eb58cd.js","gh0Kx","mdx-content.33f6db5f.js","jlICB","mdx-content.7ea3ae04.css","5Og9h","mdx-content.ed0b504e.css","l7wQo","mdx-content.59f20180.js","e268s","mdx-content.c8191a8a.js","2ypCt","banner.d9c793d9.js","23uqe","site-alert.339dbadf.js","1XLLj","cookie-consent.0c053422.js","8Kxb7","cookie-consent.c3ae535e.js","49w0k","cookie-consent.f0089bb4.css","7klEJ","home.b797f6ce.js","7k1L6","root-welcome--cover.eec7a022.jpg","id9fL","vp-01-illu.e16a91f2.png","a6qt7","vp-02-illu.23aae56a.png","2GVhB","vp-03-illu.2016f6ab.png","isHBt","user-enthusiasts.d134e85d.jpg","9tHAH","user-scientists.0f1d1c3c.jpg","iXvJF","user-researcher.a227a485.jpg","c6khv","about.0d0706ad.js","5qnpu","development.446aa5ce.js","dd4xF","container.e2eed09a.js","fsw0O","container.e4e03995.js","lrozk","single.35195558.js","56B8g","container.8355b9a9.js","8Lq6T","s-overview.41de6d95.js","iQcYK","exploration.b6ef2b37.js","lTsS1","sandbox.6a197b0c.js","5pm1r","page.8a97cd4f.js","6qhg5","img-placeholder-5.6262760b.jpg","ZIgk3","page.079da6a4.js","ha51T","chart.984895fc.js","aO0W2","aq.4cb7c0a2.csv","a93TB","two-column.ac7a3449.csv","hQzJa","sample.57667550.json","gPwZJ","table.a64955aa.js","z9aQ7","sandbox.20b125f7.css","3dTwA","user-pages.745f535a.js","benj7","index.7849b75a.css"]'));

})();
//# sourceMappingURL=index.runtime.63da869b.js.map
